import type { SaleType } from '@thevillages/schemas';

// The set of sale types that get their own dedicated, independently clustered map layer.
export const SaleTypes: SaleType[] = ['new', 'preowned', 'homesite'];
